import { useTranslation } from 'react-i18next';
import { TranscriptContent } from './TranscriptContent';
import { mapStoredToSegments } from './transcriptUtils';

import { api } from '@/store/api';

const { useGetTranscriptByContactIdQuery } = api;

interface StoredTranscriptViewProps {
  contactId: string;
  callType?: 'call' | 'chat';
  onClose?: () => void;
}

export function StoredTranscriptView({
  contactId,
  callType = 'call',
  onClose,
}: StoredTranscriptViewProps) {
  const { t } = useTranslation();

  const { data, isLoading, refetch, error } = useGetTranscriptByContactIdQuery(
    contactId,
    {
      skip: !contactId,
    }
  );
  const handleNoteAdded = () => {
    refetch();
  };

  if (isLoading)
    return <p className="text-sm text-gray-500">{t('common.loading')}</p>;
  if (error)
    return (
      <p className="text-sm text-red-600">
        {t('components.amazonConnect.errorLoadingTranscript')}
      </p>
    );
  if (!data) return null;

  const segments = mapStoredToSegments(data.transcriptions, data.transcriptId, {
    callType,
  });

  return (
    <div className="space-y-2">
      {onClose && (
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="text-sm text-gray-600 hover:text-gray-800"
          >
            {t('common.close')}
          </button>
        </div>
      )}
      <p className="text-xs font-medium text-gray-500 mb-2">
        {t('components.amazonConnect.previousMessages')}
      </p>
      <TranscriptContent
        segments={segments}
        contactId={contactId}
        onNoteAdded={handleNoteAdded}
        scrollBoxSx={{ maxHeight: '24rem' }}
        size="compact"
      />
    </div>
  );
}
